<template>
  <div class="order shadow-md">
    <!-- <span class="index"> شماره {{ index + 1 }} </span> -->
    <div v-if="order.user" class="user">
      <div class="info">
        <img
          class="avatar"
          :src="order.user.avatar.url || placeholder"
          :alt="order.user.name"
        />
        <div class="block">
          <div class="name">{{ order.user.name }}</div>
          <div class="phone">{{ order.user.phone }}</div>
        </div>
      </div>
      <div class="flex" style="flex-direction: column">
        <!--<vs-button @click="call()" size="small">تماس با کاربر</vs-button>-->
        <vs-button @click="providerPrint()" size="small"
          >پرینت مجموعه</vs-button
        >
        <vs-button class="mt-2" @click="customerPrint()" size="small"
          >پرینت مشتری</vs-button
        >
      </div>
    </div>
    <ul class="info-list">
      <li>
        نوع سفارش:
        <span class="item-text">{{ getOrderType() }}</span>
      </li>
      <li v-if="order.userDetails && order.userDetails.description">
        توضیحات:
        <span class="item-text">{{ order.userDetails.description }}</span>
      </li>
      <li
        v-if="
          (order.userDetails && order.userDetails.destination) || order.table
        "
      >
        {{ order.type === "indoor" ? "شماره میز" : "آدرس" }}:
        <span class="item-text">{{ getDestination() }}</span>
      </li>
      <li>
        وضعیت پرداخت:
        <span class="item-text" v-if="order.paymentType === 'offline'"
          >تسویه نشده (پرداخت در محل)</span
        >
        <span
          class="item-text text-success"
          v-else-if="order.paymentType === 'online'"
          >تسویه شده (آنلاین)</span
        >
      </li>
      <li v-if="order.payment">
        شماره پیگیری پرداخت:
        <span class="item-text">{{ order.payment.gateway_reference }}</span>
      </li>
    </ul>
    <h2 class="orders-list-title">لیست سفارشات :</h2>
    <ul class="orders-list">
      <li v-for="item in order.items" :key="item.id">
        <span class="order-title">{{ item.quantity }}</span>
        <span class="order-title">
          {{ item.title }}
          <span class="text-danger" v-if="item.discount && item.discount > 0"
            >(%{{ item.discount }})</span
          >
        </span>
        <span class="line"></span>
        <span class="price">{{
          (calcProductPrice(item) * item.quantity).toString().numberFormat()
        }}</span>
        <span class="rial">ریال</span>
      </li>
      <li v-if="order.discount">
        <span class="order-title text-danger">
          تخفیف
          <span>(%{{ discountDistinct }})</span>
        </span>
        <span class="line"></span>
        <span class="price text-danger">{{
          order.discount.toString().numberFormat()
        }}</span>
        <span class="rial">ریال</span>
      </li>
      <li v-if="order.userDetails.delivery">
        <span class="order-title">مبلغ پیک</span>
        <span class="line"></span>
        <span class="price">{{
          order.userDetails.delivery.fee.toString().numberFormat()
        }}</span>
        <span class="rial">ریال</span>
      </li>
      <li v-if="order.vat">
        <span class="order-title">مالیات ({{ TAX_LABEL }})</span>
        <span class="line"></span>
        <span class="price">{{ order.vat.toString().numberFormat() }}</span>
        <span class="rial">ریال</span>
      </li>
      <li>
        <span class="order-title">مبلغ پرداختی</span>
        <span class="line"></span>
        <span class="price">{{ orderPrice.toString().numberFormat() }}</span>
        <span class="rial">ریال</span>
      </li>
    </ul>
    <div class="order-status text-success" v-if="status === 'approved'">
      <feather-icon icon="CheckCircleIcon"></feather-icon>
      این سفارش تایید شده است.
    </div>
    <div
      v-if="
        status === 'approved' &&
        order.providerDetails &&
        order.providerDetails.update
      "
      class="timeleft-to-send mt-3"
    >
      <span class="title">{{ order.providerDetails.update }}</span>
    </div>
    <div class="order-status text-danger" v-if="status === 'denied'">
      <feather-icon icon="XCircleIcon"></feather-icon>
      این سفارش لغو شده است.
    </div>
    <allow-deny
      @change="status = $event"
      :order="order"
      :isPreview="true"
    ></allow-deny>
    <web-print-receipt ref="webPrintReceiptRef" :order="order" :index="index" />
    <div v-if="order.reviewer" class="reviewer">
      متصدی ثبت کننده: <span class="user-name">{{ order.reviewer.name }}</span>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import AllowDeny from "./AllowDeny";
import user_placeholder from "../../assets/images/user-placeholder.jpg";
import { convertToEnglishDigit } from "../../helpers/Functions";
import WebPrintReceipt from "../print/WebPrintReceipt.vue";
import { TAX_FEE, TAX_LABEL } from "../../helpers/Constants";

export default {
  name: "OrderPreview",
  components: {
    AllowDeny,
    WebPrintReceipt,
  },
  computed: {
    orderPrice() {
      // این Price مبلغ اصلی فاکتور است و discount مبلغ تخفیفی است که به ریال محاسبه شده است.
      // return this.order.price - this.order.discount;
      return this.order.price;
    },
    discountDistinct() {
      if (!this.order.discount) return 0;

      let price = 0;
      this.order.items.forEach((item) => {
        const discount = item.discount || 0;
        const finalPrice = item.price - item.price * (discount / 100);
        price += finalPrice * item.quantity;
      });

      return Math.round((this.order.discount * 100) / price);
    },
  },
  data() {
    return {
      status: this.order.status,
      placeholder: user_placeholder,
      receiptNumber: 0,
      TAX_LABEL,
    };
  },
  props: {
    order: {
      required: true,
      type: Object,
    },
    index: {
      requird: false,
      type: Number,
    },
  },
  methods: {
    getDestination() {
      if (this.order.type === "indoor") {
        return this.order.table?.title || this.order.userDetails.destination;
      }

      return convertToEnglishDigit(this.order.userDetails.destination);
    },
    getOrderType() {
      if (this.order.type === "indoor") {
        return "داخل سالن";
      } else if (this.order.type === "outdoor") {
        return "ارسالی";
      } else {
        return "تحویل در محل";
      }
    },
    getProcessingTime() {
      if (this.order.providerDetails) {
        const time = moment(this.order.providerDetails.processingTime).format(
          "HH:mm"
        );
        return time;
      }

      return null;
    },
    call() {
      window.location.href = "tel:" + this.order.user.phone;
    },
    calcProductPrice(product, withTax = false) {
      let tax = 0;

      if (withTax && this.order.vat > 0) {
        tax = product.tax || TAX_FEE;
      }

      const discount = product.discount || 0; // Discount of item
      const priceWithDiscount =
        product.price - product.price * (discount / 100); // Calculated price with discount
      const finalPrice = priceWithDiscount + priceWithDiscount * tax; // Calculated price with tax

      return finalPrice;
    },
    calcProductsPriceSum(items, withTax = false) {
      if (items) {
        let price = 0;
        items.forEach((element) => {
          price += this.calcProductPrice(element, withTax) * element.quantity;
        });
        return price;
      }

      return 0;
    },
    providerPrint() {
      this.$refs["webPrintReceiptRef"].providerPrint();
    },
    customerPrint() {
      this.$refs["webPrintReceiptRef"].customerPrint();
    },
  },
};
</script>

<style scoped lang="scss">
.order {
  padding: 15px;
  background-color: #ffffff;
  font-size: 13px;
  border-radius: 15px;

  .index {
    font-size: 18px;
    color: #000000;
    font-weight: 700;
    margin-bottom: 10px;
    display: block;
  }

  .user {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .info {
      display: flex;

      .avatar {
        display: block;
        width: 60px;
        height: 60px;
        object-fit: cover;
        object-position: center;
        border-radius: 50%;
        border: 1px solid #111111;
        padding: 1px;
        margin-right: 10px;
      }

      .phone,
      .name {
        font-weight: 700;
        color: #000000;
      }
    }
  }

  .info-list {
    margin-top: 10px;

    & > li:not(:first-child) {
      margin-top: 5px;
    }

    .item-text {
      font-weight: 700;
      color: #000000;
    }
  }

  .orders-list-title {
    font-size: inherit;
    font-weight: 700;
  }

  .orders-list,
  .orders-list-title {
    margin-top: 10px;
  }

  .orders-list > li {
    margin-top: 10px;
    display: flex;
    align-items: center;
    font-size: 15px;

    .price,
    .order-title {
      font-weight: 700;
      color: #000000;
      margin-left: 5px;
    }

    .rial {
      font-size: 12px;
      margin-left: 5px;
    }

    .line {
      flex: 1;
      height: 1px;
      background-color: #d8d8d8;
      margin: 0 5px;
    }
  }

  .order-status {
    display: flex;
    align-items: center;
    margin-top: 10px;
    font-weight: 700;
    color: #000000;

    .feather-icon {
      color: inherit;
      margin-right: 5px;
    }
  }

  .timeleft-to-send {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .title {
      font-weight: 600;
      color: #000000;
    }
  }

  .reviewer {
    font-size: 14px;
    margin-top: 10px;
    color: #000000;

    .user-name {
      font-weight: 900;
    }
  }
}
</style>
